import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'onlineMessages',
        url: '/onlineMessages?beginDate&endDate',
        component: 'wtOnlineMessagesState',
        params: {
            beginDate: '',
            endDate: ''
        },
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 1100,
            visible: false,
            icon: 'fa-indent',
            displayName: 'Online messages',
            editRoles: [],
            editButtonVisibility: () => false,
            ignoreHistory: false
        }
    }];

export default states;